<template>
  <mobile-responsive-shell :title="title">
    <desktop-view />
  </mobile-responsive-shell>
</template>

<script>
import MobileResponsiveShell from "../components/MobileResponsiveShell.vue";
import DesktopView from "@/views/stocks/Create.vue";

export default {
  name: "MobileStocksCreate",
  components: {
    MobileResponsiveShell,
    DesktopView,
  },
  data() {
    return {
      title: "Ajout stock",
    };
  },
};
</script>
